import React from 'react';
import PropTypes from 'prop-types';
import {
  FormattedMessage,
  useIntl,
} from 'react-intl';
import { Field } from 'react-final-form';

import {
  Col,
  Loading,
  Row,
  Selection,
} from '@folio/stripes/components';

import {
  handleFormDataChange,
  validateRequiredField,
} from '../../../utils';
import {
  ASSIGNED_USER_NAME,
  ASSIGNED_USER_ID,
  TEAM,
  ASSIGNED_USER_ID_INITIAL_VALUE,
  ASSIGNED_USER_NAME_INITIAL_VALUE,
  TEAM_FIELDS,
} from '../../../constants';

const getFormattedOptions = (teams) => teams.map((team) => {
  return ({
    value: team.id,
    label: team.name
  });
});

const SelectTeam = ({
  isObjectDataFormat,
  id,
  name,
  teams,
  change,
  getUsers,
}) => {
  const intl = useIntl();

  if (teams.length) {
    const teamsSelectOptions = getFormattedOptions(teams);

    const getTeamName = (teamId) => {
      const selectedTeam = teams.filter((team) => team.id === teamId)[0];

      return selectedTeam.name;
    };

    return (
      <Col
        data-test-assign-team
        sm={4}
      >
        <Field
          required
          component={Selection}
          dataOptions={teamsSelectOptions}
          id={id}
          label={<FormattedMessage id="ui-task-list.task.field.selectTeam" />}
          name={name}
          placeholder={intl.formatMessage({ id: 'ui-task-list.task.field.selectTeam.placeholder' })}
          validate={validateRequiredField}
          onChange={(value) => {
            getUsers(value);

            const changeValues = {
              [ASSIGNED_USER_ID]: ASSIGNED_USER_ID_INITIAL_VALUE,
              [ASSIGNED_USER_NAME]: ASSIGNED_USER_NAME_INITIAL_VALUE,
              [TEAM]: {
                [TEAM_FIELDS.ID]: value,
                [TEAM_FIELDS.NAME]: getTeamName(value),
              },
            };

            handleFormDataChange(changeValues, isObjectDataFormat, change);
          }}
        />
      </Col>
    );
  } else {
    return (
      <Row middle="sm">
        <Col sm={3}>
          <Loading />
        </Col>
      </Row>
    );
  }
};

SelectTeam.propTypes = {
  change: PropTypes.func.isRequired,
  getUsers: PropTypes.func.isRequired,
  teams: PropTypes.array.isRequired,
  id: PropTypes.string,
  isObjectDataFormat: PropTypes.bool,
  name: PropTypes.string
};

SelectTeam.defaultProps = {
  isObjectDataFormat: false,
  id: `${TEAM}.${TEAM_FIELDS.ID}`,
  name: `${TEAM}.${TEAM_FIELDS.ID}`,
};

export default SelectTeam;
